var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNamebox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 103,
    viewBox: "0 0 109 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.738281 19C0.738281 8.50659 9.24487 0 19.7383 0H108.738V103H54.7383C24.9149 103 0.738281 78.8234 0.738281 49V19Z",
    fill: "url(#paint0_linear_784_9198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9766 53.4271C50.072 53.4271 46.9374 50.2925 46.9374 46.388C46.9374 42.5384 50.072 39.3488 53.9766 39.3488C57.8261 39.3488 61.0157 42.5384 61.0157 46.388C61.0157 50.2925 57.8261 53.4271 53.9766 53.4271ZM58.871 55.1869C62.9405 55.1869 66.2951 58.5415 66.2951 62.611V64.8657C66.2951 66.3506 65.0852 67.5054 63.6554 67.5054H44.2977C42.8129 67.5054 41.6581 66.3506 41.6581 64.8657V62.611C41.6581 58.5415 44.9577 55.1869 49.0272 55.1869H49.962C51.1719 55.7918 52.5467 56.0668 53.9766 56.0668C55.4064 56.0668 56.7262 55.7918 57.9361 55.1869H58.871Z",
    fill: "#500188"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_784_9198",
    x1: 0.738281,
    y1: 0,
    x2: 103.623,
    y2: 107.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamebox);
export default __webpack_public_path__ + "static/media/Namebox.b1c18fda2d13391a990fc60b71871a32.svg";
export { ForwardRef as ReactComponent };